import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import $image_url from 'js/utils/image_url';
import { MoreButton } from 'javascripts/analytics/components/more_button';
import { PremiumIcon } from 'javascripts/analytics/components/premium_icon';
import { KeywordsHitsTableRow } from './keywords_hits_table_row';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

export const KeywordsHitsTable = createReactClass({
  propTypes: {
    hits: PropTypes.array.isRequired,
    header: PropTypes.string.isRequired,
    showKeywords: PropTypes.bool.isRequired,
    info: PropTypes.string.isRequired,
    isShareable: PropTypes.bool,
    showSearchEngine: PropTypes.bool,
    showPremiumIcon: PropTypes.bool,
    isNewFeature: PropTypes.bool.isRequired,
  },

  getInitialState: function () {
    const highlightedRow = $a.query_param('keyword_target');

    if (highlightedRow !== null) {
      const urlParts = $a.decompose_url(window.location.href);
      const pathWithoutKeywordTargetParam = $a.build_url(
        urlParts[0],
        _.reject(urlParts[1], function (p) {
          return p[0] === 'keyword_target';
        }),
        urlParts[2],
      );
      window.history.replaceState({}, '', pathWithoutKeywordTargetParam);
    }

    return {
      numVisibleRows: 10,
      highlightedRow: highlightedRow,
    };
  },

  popoverOptions: {
    popoverText:
      'Your paper appeared in an Academia.edu search result with this term.',
    popoverLink: $r.upgrade_url({
      feature: 'keywords',
      trigger: 'internal-keywords',
    }),
    popoverContainer: 'body',
  },

  keywordPopoverImpression: {
    source: 'analytics-upgrade-door',
    key: 'keywords_popover',
    extra: {
      door: 'keywords_popover',
      trigger: 'internal-keywords',
    },
  },

  trackKeywordUpgradeClick: function () {
    trackAnalyticsClick('analytics-upgrade-door', {
      door: 'keywords_popover',
      trigger: 'internal-keywords',
    });
  },

  moreButtonClickHandler: function () {
    this.setState({
      numVisibleRows: this.state.numVisibleRows + 20,
    });
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderMoreButton: function () {
    return (
      <MoreButton
        onClick={this.moreButtonClickHandler}
        trackingTable="keywords"
      />
    );
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderSearchEngineHeader: function () {
    const text = this.props.showSearchEngine ? 'Search Engine' : '';
    return <th className="premium-hits-table-th">{text}</th>;
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderKeywordColumnTitle: function () {
    if (!this.props.showPremiumIcon) {
      return <span>Keywords</span>;
    }
    return (
      <span className="u-pv2x PremiumIconContainerHoverWrapper js-PremiumIconContainerHoverWrapper">
        <PremiumIcon
          style={{ top: '-1px' }}
          className="u-positionRelative"
          popoverBodyText={this.popoverOptions.popoverText}
          popoverLinkUrl={this.popoverOptions.popoverLink}
          popoverContainer={this.popoverOptions.popoverContainer}
          disableHoverBehavior={this.props.showKeywords}
          onPopoverLinkClick={this.trackKeywordUpgradeClick}
          popoverImpression={this.keywordPopoverImpression}
        />
        &nbsp;&nbsp;Search Term
      </span>
    );
  },

  incrementHashValue: function (hash, key) {
    if (key in hash) {
      hash[key] += 1;
    } else {
      hash[key] = 1;
    }
    return hash[key];
  },

  deduplicatedHits: function (hits, maxRepeats) {
    const deduplicatedHits = [];
    const seenQueries = {};
    for (let i = 0; i < hits.length; i++) {
      const hit = hits[i];
      const key = hit.referer.query + hit.referer.time;
      const timesSeen = this.incrementHashValue(seenQueries, key);
      if (timesSeen <= maxRepeats) {
        deduplicatedHits.push(hit);
      }
    }
    return deduplicatedHits;
  },

  visibleHits: function () {
    const deduplicatedHits = this.deduplicatedHits(this.props.hits, 3);

    return _.sortBy(deduplicatedHits, function (hit) {
      // Sort by date, show most recent first
      return -1 * hit.epoch;
    }).slice(0, this.state.numVisibleRows);
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  renderEmptyRow: function () {
    return (
      <div className="u-borderTop1 u-borderColorGrayLight u-p5x">None</div>
    );
  },

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line react/display-name
  render: function () {
    const visibleHits = this.visibleHits();

    return (
      <div className="panel panel-flat a-fadeInDown">
        <div className="u-p5x u-tcGrayDarker">
          <div>
            <span className="u-fw700">{this.props.header}</span>
            {this.props.isNewFeature && (
              <img
                className="u-ml2x"
                style={{ marginTop: '-2px' }}
                src={$image_url('icons/new_badge.svg')}
              />
            )}
          </div>
          <span className="u-fontStyleItalic u-fs13">{this.props.info}</span>
        </div>
        <div className="panel-horizontal-split"></div>
        <table className="analytics-dashboard-data-table table">
          <thead className="premium-hits-table-thead">
            <tr className="u-bgColorGrayLightest">
              <th className="premium-hits-table-th">Time</th>
              <th className="premium-hits-table-th col-xs-1 u-taCenter">
                Rank
              </th>
              <th className="premium-hits-table-th">Page</th>
              {this.renderSearchEngineHeader()}
              <th className="premium-hits-table-th">
                {this.renderKeywordColumnTitle()}
              </th>
            </tr>
          </thead>
          <tbody>
            {_.map(
              visibleHits,
              function (hit) {
                return (
                  <KeywordsHitsTableRow
                    hit={hit}
                    key={'hit_' + hit.id}
                    showKeywords={this.props.showKeywords}
                    isShareable={this.props.isShareable}
                    showSearchEngine={this.props.showSearchEngine}
                    showPremiumIcon={this.props.showPremiumIcon}
                    popoverOptions={this.popoverOptions}
                    highlighted={
                      this.state.highlightedRow === hit.id.toString()
                    }
                  />
                );
              },
              this,
            )}
          </tbody>
        </table>
        {visibleHits.length === 0 && this.renderEmptyRow()}
        <div className="panel-horizontal-split"></div>
        <div className="u-taCenter">
          {this.props.hits.length > this.state.numVisibleRows &&
            this.renderMoreButton()}
        </div>
      </div>
    );
  },
});
